import { render, staticRenderFns } from "./SelectInputResourceful.vue?vue&type=template&id=366cc6ad&"
import script from "./SelectInputResourceful.vue?vue&type=script&lang=js&"
export * from "./SelectInputResourceful.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports